webpackJsonp([1],{

/***/ 111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_tables_2__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_serialize__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Modal__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Modal__);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

var data = [];
var metadata = { log: [] };
var getAndLoadDict = function getAndLoadDict(url) {
  __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url).then(function (response) {
    var displayData = __WEBPACK_IMPORTED_MODULE_6__lib_serialize__["a" /* default */].dictToDisplay(response.data);
    loadDict(displayData);
  });
};

var loadDict = function loadDict(displayData) {
  data.push.apply(data, displayData.display);
  metadata = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(displayData.metadata);
};

var addEntry = function addEntry(entry) {
  var term = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(entry, 'wikidata.labels.en.value');
  if (!(term === undefined)) {
    data.push({
      wikidata: entry.text,
      contentmine: getNextID(),
      name: term,
      term: term
    });
  }
};

var logQuery = function logQuery(queryString) {
  metadata.log.push({
    type: 'wdqs',
    query: queryString,
    time: Date.now()
  });
};

var logPagePile = function logPagePile(PagePileID) {
  metadata.log.push({
    type: 'pagepile',
    id: PagePileID,
    time: Date.now()
  });
};

var getNextID = function getNextID() {
  var ids = data.map(function (row) {
    return parseInt(row.contentmine.match(/(\d+)$/)[0]);
  });
  var max = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.max(ids);
  if (max === undefined) max = -1;
  var newid = parseInt(max) + 1;
  return 'CM.' + metadata.id + newid;
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('wikidata', {
  props: ['data'],
  template: '<a v-bind:href="wUrl">{{data.wikidata}}</a>',
  computed: {
    wUrl: function wUrl() {
      return 'https://wikidata.org/wiki/' + this.data.wikidata;
    }
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('modal', __WEBPACK_IMPORTED_MODULE_7__components_Modal___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_tables_2__["ClientTable"]);
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  data: {
    showModal: false,
    downloadContent: null,
    showDictSelector: true,
    showTable: false,
    columns: ['contentmine', 'term', 'name', 'wikidata'],
    tableData: data,
    metadata: metadata,
    options: {
      templates: {
        wikidata: 'wikidata'
      },
      customFilters: [{
        name: 'prefix',
        callback: function callback(row, query) {
          return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.upperCase(row.term[0]) === query;
        }
      }]
    },
    dicts: [{ name: 'Cochrane', url: 'https://rawgit.com/ContentMine/dictionaries/master/json/cochrane.json' }, { name: 'Wikidata Country', url: 'https://rawgit.com/ContentMine/dictionaries/master/json/wikidatacountry.json' }, { name: 'insecticides', url: 'https://rawgit.com/ContentMine/dictionaries/master/json/insecticides.json' }, { name: 'disease', url: 'https://rawgit.com/ContentMine/dictionaries/master/json/disease.json' }],
    prefixes: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
  },
  methods: {
    dictLoad: function dictLoad(dict) {
      getAndLoadDict(dict.url);
      this.showDictSelector = false;
      this.showTable = true;
    },
    prefixFilter: function prefixFilter(prefix) {
      __WEBPACK_IMPORTED_MODULE_2_vue_tables_2__["Event"].$emit('vue-tables.filter::prefix', prefix);
    },
    startDownload: function startDownload() {
      this.downloadContent = 'data:application/json;charset=utf-8,' + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_6__lib_serialize__["a" /* default */].displayToDict(this.tableData, this.metadata), null, 4));
    },
    newDict: function newDict() {
      this.showDictSelector = false;
      this.showTable = true;
    },
    loadDictionary: function loadDictionary(e) {
      var fReader = new window.FileReader();
      var self = this;
      fReader.onload = function (event) {
        var displayData = __WEBPACK_IMPORTED_MODULE_6__lib_serialize__["a" /* default */].dictToDisplay(JSON.parse(event.target.result));
        loadDict(displayData);
        self.showDictSelector = false;
        self.showTable = true;
      };
      fReader.readAsText(e.target.files[0]);
    }
  }
}).$on('newentity', addEntry).$on('updateQuery', logQuery).$on('updatePagePile', logPagePile);

/***/ }),

/***/ 112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_wikidata_sdk__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_wikidata_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_wikidata_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jsonp__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jsonp__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modal',
  methods: {
    emitNewEntries: function emitNewEntries(wids) {
      var _this = this;

      var urls = __WEBPACK_IMPORTED_MODULE_2_wikidata_sdk___default.a.getManyEntities(wids);
      var downloadPromises = urls.map(function (url) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url);
      });
      return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all(downloadPromises).then(function (responses) {
        var entities = {};
        responses.map(function (response) {
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(entities, response.data.entities);
        });
        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(entities, function (value, key) {
          _this.$parent.$emit('newentity', { wikidata: value, text: key });
        });
        _this.$emit('close');
      });
    },
    doSparqlQuery: function doSparqlQuery() {
      // Snippet inspired by wikidata-sdk https://github.com/maxlath/wikidata-sdk/blob/master/lib/utils/utils.js
      var encodeCharacter = function encodeCharacter(c) {
        return '%' + c.charCodeAt(0).toString(16);
      };
      var escapedQueryString = encodeURIComponent(this.queryString).replace(/[!'()*]/g, encodeCharacter);
      var me = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://query.wikidata.org/sparql?format=json&query=' + escapedQueryString).then(function (response) {
        var wids = __WEBPACK_IMPORTED_MODULE_2_wikidata_sdk___default.a.simplifySparqlResults(response.data);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(wids);
      }).then(this.emitNewEntries).then(this.$parent.$emit('updateQuery', me.queryString));
    },
    doPagePile: function doPagePile() {
      var me = this;
      __WEBPACK_IMPORTED_MODULE_4_jsonp___default()('https://tools.wmflabs.org/pagepile/api.php?id=' + this.pagePileID + '&action=get_data&doit&format=json', null, function (err, data) {
        if (err) {
          console.error(err.message);
        } else {
          me.emitNewEntries(data.pages);
          me.$parent.$emit('updatePagePile', me.pagePileID);
        }
      });
    }
  },
  data: function data() {
    return {
      queryString: undefined,
      pagePileID: undefined
    };
  }
});

/***/ }),

/***/ 156:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 196:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_vm._v("\n          Add Items to Dictionary\n        ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.doSparqlQuery($event)
      }
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryString),
      expression: "queryString"
    }],
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "name": "sparql_query",
      "id": "sparql_query",
      "placeholder": "Paste your query here where the ?item parameter returns all the items you want in the dictionary"
    },
    domProps: {
      "value": (_vm.queryString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryString = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Run Query")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.doPagePile($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pagePileID),
      expression: "pagePileID"
    }],
    attrs: {
      "placeholder": "PagePile ID"
    },
    domProps: {
      "value": (_vm.pagePileID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pagePileID = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Run PagePile")])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "btn btn-danger modal-default-button",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("\n            Close\n          ")])])], 2)])])])
},staticRenderFns: []}

/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


// transfrom from CM dictionary to flat format for display
var dictToDisplay = function dictToDisplay(dict) {
  var metadata = {
    id: dict.id
  };
  var display = dict.entries.map(function (x) {
    var y = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omit(x, 'identifiers'));
    y.contentmine = x.identifiers.contentmine;
    if (!(x.identifiers.wikidata === undefined)) {
      y.wikidata = x.identifiers.wikidata;
    }
    return y;
  });
  return { display: display, metadata: metadata };
};

// transfrom from flat display format to CM dictionary for Download
var displayToDict = function displayToDict(display, metadata) {
  var dict = {};
  dict.id = metadata.id;
  dict.log = metadata.log;
  dict.entries = display.map(function (x) {
    var y = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omit(x, ['wikidata', 'contentmine']));
    y.identifiers = {};
    y.identifiers.contentmine = x.contentmine;
    if (!(x.wikidata === undefined)) {
      y.identifiers.wikidata = x.wikidata;
    }
    return y;
  });
  return dict;
};

var serialize = {
  displayToDict: displayToDict,
  dictToDisplay: dictToDisplay
};

/* harmony default export */ __webpack_exports__["a"] = (serialize);

/***/ }),

/***/ 83:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(156)
}
var Component = __webpack_require__(195)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(196),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2d82d72a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

},[111]);


// WEBPACK FOOTER //
// static/js/app.19498ababdc99643d1e3.js